<template>
    <article class="i-presentations">
        <h2
            class="i-presentations__header"
            :title="presentationsData.header"
            v-html="presentationsData.header"></h2>
        <div class="i-presentations__wrap">
            <h3
                class="i-presentations__title"
                :title="apiData.title"
                v-html="apiData.title"></h3>
            <p
                class="i-presentations__desc"
                v-html="apiData.subtitle"></p>
        </div>
        <div class="i-presentations__footer">
            <a
                class="i-presentations__download"
                :href="apiData.src"
                :download="apiData.name">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 13L4 9L12 9L8 13Z" fill="#252628"/>
                    <path d="M8 9L8 1" stroke="#252628"/>
                    <path d="M3 15H13" stroke="#252628"/>
                </svg>
                <span
                    v-html="apiData.extension.toUpperCase() + ' ' + apiData.size"></span>
            </a>
            <a
                v-if="apiData.link"
                class="i-presentations__link arrow-btn"
                :href="apiData.link"></a>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'Presentations',
        props: {
            presentationsData: {
                type: Object,
                default: () => {}
            },
            apiData: {
                type: Object,
                default: () => {}
            }
        },
    }
</script>
